"use client";

import type { File } from "@rmh/defs";
import { filesize } from "filesize";
import dayjs from "dayjs";
import Image from "next/image";
import TextFileIcon from "../../assets/images/text-file-icon.png";

const FileView = ({
  fileUrl,
  file,
  fileName,
}: {
  fileUrl: string;
  file?: File;
  fileName?: string;
}) => {
  const downloadFile = (): void => {
    if (!fileUrl) return;
    window.open(fileUrl, "_blank");
  };

  return (
    <button
      className="flex gap-2 overflow-hidden text-ellipsis whitespace-nowrap rounded-2xl bg-gray-50 p-4"
      onClick={downloadFile}
      type="button"
    >
      <div className="flex-none items-center">
        <Image alt="file" height={42} src={TextFileIcon.src} width={42} />
      </div>
      <div className="flex-1 overflow-hidden text-ellipsis whitespace-nowrap">
        {fileName || file?.fileName ? (
          <div className="body-l-strong overflow-hidden text-ellipsis whitespace-nowrap text-left text-black">
            {fileName || file?.fileName}
          </div>
        ) : null}
        <div className="mt-2 flex justify-between">
          <div className="text-rmh-blue-400 underline">View</div>
          {file ? (
            <div className="text-rmh-gray-500 overline-l flex items-center gap-3">
              <div>{dayjs(file.uploadedOn).format("MM/DD/YYYY")}</div>
              <div>-</div>
              {file.fileBytesSize && (
                <div>{filesize(file.fileBytesSize, { standard: "jedec" })}</div>
              )}
            </div>
          ) : null}
        </div>
      </div>
    </button>
  );
};

export default FileView;
